import {Component, OnInit} from '@angular/core';
import {NavigationTriggerService} from '@app/services/admin/navigation-trigger.service';

@Component({
  selector: 'app-global-custodians-lending',
  templateUrl: './global-custodians-lending.component.html',
  styleUrls: ['./global-custodians-lending.component.scss']
})
export class GlobalCustodiansLendingComponent implements OnInit {
  isChild = true;

  constructor(private navigationTriggerService: NavigationTriggerService) {

  }

  ngOnInit() {
    this.navigationTriggerService.setSubMenu(false);
  }
}
